module.exports = __webpack_public_path__ + "static/Anbaugebiet-Baden-600x793-9ed2bc6f848ce1809083960dff800a55.jpeg";